import { EsignAutosignStatus } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const esignAutosignStatusMessage = defineMessages({
  approved: {
    defaultMessage: 'Approved',
    description: 'mekari auto-sign status',
  },
  notRegistered: {
    defaultMessage: 'Not registered',
    description: 'mekari auto-sign status',
  },
  pendingApproval: {
    defaultMessage: 'Pending approval',
    description: 'mekari auto-sign status',
  },
})

export function translateEsignAutosignStatus(intl: IntlShape, status: EsignAutosignStatus): string {
  switch (status) {
    case EsignAutosignStatus.APPROVED:
      return intl.formatMessage(esignAutosignStatusMessage.approved)
    case EsignAutosignStatus.NOT_REGISTERED:
      return intl.formatMessage(esignAutosignStatusMessage.notRegistered)
    case EsignAutosignStatus.PENDING_APPROVAL:
      return intl.formatMessage(esignAutosignStatusMessage.pendingApproval)
  }
}
